import type { ArticleForm } from './articleDraft'
import { stripHtml } from './stripHtml'

type Slots = Pick<ArticleForm, 'title' | 'content' | 'titleEn' | 'contentEn'>

const full = (title?: string | null, content?: string | null): boolean =>
  !!title?.trim() && !!stripHtml(content ?? '').trim()

/**
 * Чего не хватает статье, чтобы её сохранить. Хватит одного языка, где есть и
 * заголовок, и текст: бэк требует хотя бы один заголовок (`InstructionCreate`), а
 * статья, начатая при английском интерфейсе, пишется в EN-слоты (`useEditLang`).
 * Подсказка — «заголовок», пока его нет ни в одном языке, иначе «текст».
 */
export const articleGap = (form: Slots): 'title' | 'content' | null => {
  if (full(form.title, form.content) || full(form.titleEn, form.contentEn)) return null
  return form.title.trim() || form.titleEn?.trim() ? 'content' : 'title'
}

/** Текст, по которому считается время чтения: RU, если он полон, иначе EN. */
export const articleReadingSource = (form: Slots): string =>
  full(form.title, form.content) ? form.content : (form.contentEn ?? '')
